import React, {Component} from "react";

class OfflineComponent extends Component {
	render() {
		return (
			<React.Fragment>
				<div className="bg-white" style={{ height: "100vh" }}>
					<div className="d-flex justify-content-center pt-100 mb-20">

						<img
							className="offline-mode-img text-center"
							src="/assets/img/various/offline.png"
							alt={localStorage.getItem("offlineTitleMessage")}
						/>

					</div>
					<h2 className="text-center font-w700 mb-3" style={{
						fontFamily: "Poppins",

					}}>Ayyo! Your're away</h2>
					<h2 className="text-muted text-center" style={{
						fontSize: "14px",
						fontWeight: 500,
						fontFamily: 'Montserrat',
						padding: "0 2.5rem"
					}}>
						Looks like you are offline. Please connect to internet to continue using the app.
					</h2>
				</div>
			</React.Fragment>
		);
	}
}

export default OfflineComponent;
